// AS TRAINING — Exercise technique catalog
// Grupos musculares: back, biceps, chest, shoulders, legs, triceps, core

export const EXERCISES = [
  // ============== ESPALDA ==============
  {
    id: "remo-barra",
    name: "Remo con Barra",
    muscle_group: "back",
    equipment: "gym",
    tags: ["fuerza", "espalda", "control"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/6h8wrc89_file_000000003150720caa8246931b8f6db4.png",
    execution: [
      "De pie con los pies al ancho de los hombros y rodillas ligeramente flexionadas.",
      "Lleva la cadera hacia atrás e inclina el torso hacia adelante manteniendo la espalda recta.",
      "Agarra la barra con agarre pronado, ligeramente más ancho que los hombros.",
      "Inicia el movimiento llevando los codos hacia atrás, manteniéndolos cerca del cuerpo.",
      "Lleva la barra hasta la parte baja del abdomen o el ombligo, apretando los omóplatos.",
      "Mantén 1 segundo la contracción máxima.",
      "Baja la barra de forma lenta y controlada, extendiendo los brazos completamente sin perder la alineación.",
    ],
    muscles: ["Dorsales (ancho)", "Romboides", "Trapecio medio e inferior", "Deltoides posterior", "Bíceps (secundario)", "Erectores espinales (estabilizadores)"],
    benefits: [
      "Aumenta el grosor y la densidad de la espalda.",
      "Mejora la postura y reduce el riesgo de lesiones.",
      "Fortalece la cadena posterior.",
      "Mejora el rendimiento en otros ejercicios compuestos.",
      "Desarrolla fuerza funcional y estética.",
    ],
    keys: [
      "Mantén la espalda recta en todo momento.",
      "Activa el core para proteger la zona lumbar.",
      "Lleva los codos hacia atrás, no hacia los lados.",
      "Usa un peso que te permita controlar el movimiento.",
      "Enfócate en la contracción de la espalda.",
    ],
    errors: [
      "Redondear la espalda.",
      "Usar demasiado peso.",
      "Impulsarse con el cuerpo.",
      "Elevar los hombros.",
      "No hacer el rango completo.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 12 REPETICIONES",
    rest: "60 - 90 SEG",
  },
  {
    id: "remada-mancuerna",
    name: "Remada con Mancuernas",
    muscle_group: "back",
    equipment: "gym",
    tags: ["unilateral", "grosor", "control"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/krz4du5l_file_00000000e958720c937f7f912ea6ea04.png",
    execution: [
      "Apoya una rodilla y la mano del mismo lado en el banco.",
      "La otra pierna firme en el suelo para estabilidad.",
      "Toma la mancuerna con agarre neutro (palma mirando al cuerpo).",
      "Mantén la espalda recta, pecho abierto y core activo.",
      "Tira de la mancuerna hacia tu cadera, llevando el codo pegado al cuerpo.",
      "Aprieta los dorsales al final del movimiento.",
      "Baja la mancuerna de forma controlada hasta extender completamente el brazo.",
      "Siente el estiramiento en el dorsal antes de la siguiente repetición.",
    ],
    muscles: ["Dorsal ancho (principal)", "Redondo mayor", "Trapecio medio e inferior", "Romboides", "Deltoides posterior", "Bíceps (secundario)"],
    benefits: [
      "Desarrolla el grosor y forma del dorsal.",
      "Corrige asimetrías al trabajar cada lado independientemente.",
      "Mejora la estabilidad del core.",
      "Rango de movimiento amplio y natural.",
      "Menor estrés lumbar que el remo con barra.",
    ],
    keys: [
      "Usa un peso que te permita buena técnica.",
      "No gires ni inclines el torso.",
      "Mantén el core activo durante todo el movimiento.",
      "Controla la bajada, evita dejar caer el peso.",
      "Enfócate en contraer los dorsales, no solo los brazos.",
    ],
    errors: [
      "Rotar el torso al subir el peso.",
      "Usar impulso o balanceo.",
      "Redondear la espalda.",
      "Elevar el hombro hacia la oreja.",
      "No completar el rango de movimiento.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 12 REPETICIONES POR LADO",
    rest: "60 SEG",
  },
  {
    id: "remada-maquina",
    name: "Remada en Máquina",
    muscle_group: "back",
    equipment: "gym",
    tags: ["seguridad", "aislamiento", "volumen"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/zmb8rksr_file_00000000ab50722fbce90e42920708ab.png",
    execution: [
      "Siéntate y apoya el pecho en el soporte de la máquina.",
      "Agarra las manijas con un agarre neutro (palmas enfrentadas).",
      "Extiende los brazos completamente y lleva los hombros ligeramente hacia adelante.",
      "Mantén la espalda recta y el core activado.",
      "Tira de las manijas hacia tu abdomen llevando los codos cerca del cuerpo.",
      "Aprieta los omóplatos al final del movimiento contrayendo la espalda.",
      "Mantén el pecho apoyado y la espalda recta en todo momento.",
      "Extiende los brazos de forma controlada hasta volver a la posición inicial.",
      "Permite que los omóplatos se estiren sin perder el control.",
    ],
    muscles: ["Dorsal ancho (principal)", "Romboides", "Trapecio medio e inferior", "Redondo mayor", "Deltoides posterior", "Bíceps (secundario)"],
    benefits: [
      "Aísla la espalda al eliminar la estabilización del torso.",
      "Ideal para principiantes por su trayectoria fija.",
      "Menor estrés lumbar que ejercicios con barra.",
      "Permite altas cargas de forma segura.",
      "Excelente para hipertrofia y densidad de espalda.",
    ],
    keys: [
      "Usa un peso que te permita buena técnica.",
      "Enfócate en juntar los omóplatos, no solo en mover peso.",
      "Mantén el torso estable y evita arquear la espalda.",
      "Controla el movimiento en la fase excéntrica (al regresar).",
      "Respira: exhala al tirar, inhala al regresar.",
    ],
    errors: [
      "Usar demasiado peso comprometiendo la técnica.",
      "Balancear el torso.",
      "Elevar los hombros hacia las orejas.",
      "No completar el rango de movimiento.",
      "Soltar el peso bruscamente al regresar.",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 12 REPETICIONES",
    rest: "60 SEG",
  },
  {
    id: "pull-down-maquina",
    name: "Pull Down en la Máquina",
    muscle_group: "back",
    equipment: "gym",
    tags: ["espalda ancha", "fuerza", "volumen"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/0po5r9q9_file_00000000dd14722f820dcc18048a922a.png",
    execution: [
      "Siéntate en la máquina y ajusta los muslos debajo de los soportes.",
      "Agarra la barra con un agarre amplio, por encima de los hombros.",
      "Mantén el pecho elevado y la espalda recta.",
      "Tira de la barra hacia abajo controladamente hasta la parte superior del pecho.",
      "Regresa lentamente a la posición inicial sin soltar la tensión.",
      "Mantén el torso estable y evita balancearte durante todo el ejercicio.",
    ],
    muscles: ["Dorsal mayor", "Redondo mayor", "Bíceps braquial", "Romboides"],
    benefits: [
      "Desarrolla una espalda más ancha y en forma de V.",
      "Mejora la postura y la estabilidad escapular.",
      "Aumenta la fuerza de tracción.",
      "Ideal para prevenir lesiones de hombro.",
    ],
    keys: [
      "Mantén la espalda recta en todo momento.",
      "No balancees el cuerpo ni uses impulso.",
    ],
    errors: [
      "Usar demasiado peso y balancearse.",
      "Llevar los codos hacia adelante.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 12 REPETICIONES",
    rest: "45 - 60 SEG",
  },
  {
    id: "pull-down-atras-cabeza",
    name: "Pull Down Atrás de la Cabeza",
    muscle_group: "back",
    equipment: "gym",
    tags: ["espalda ancha", "fuerza", "desarrollo"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/kmopzfa4_file_000000006e30722fb80d91fafd4709f6.png",
    execution: [
      "Siéntate en la máquina y ajusta los muslos debajo de los soportes.",
      "Agarra la barra con un agarre amplio, por encima de los hombros.",
      "Lleva la barra hacia abajo por detrás de la cabeza, bajando los codos hacia los costados.",
      "Contrae los dorsales en la parte baja del movimiento.",
      "Sube lentamente y regresa a la posición inicial con control.",
      "Mantén el pecho elevado y la espalda neutra durante todo el ejercicio.",
    ],
    muscles: ["Dorsal mayor", "Redondo mayor", "Trapecio inferior", "Deltoides posterior"],
    benefits: [
      "Aumenta el ancho de la espalda.",
      "Mejora la definición y separación muscular.",
      "Activa intensamente los dorsales y la parte media de la espalda.",
    ],
    keys: [
      "Mantén el cuello relajado.",
      "No fuerces si tienes limitación de movilidad de hombro.",
    ],
    errors: [
      "Bajar demasiado la barra sin movilidad.",
      "Llevar los codos hacia adelante.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 10 REPETICIONES",
    rest: "60 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/l6isiaft_690922947_1783025396023320.mp4",
  },
  {
    id: "remada-cable",
    name: "Remada en el Cable",
    muscle_group: "back",
    equipment: "gym",
    tags: ["espalda fuerte", "postura", "rendimiento"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/tkdizyy3_file_000000002e1c720c808a56107e32e070.png",
    execution: [
      "Siéntate en la máquina con los pies apoyados en la plataforma.",
      "Sujeta el agarre con ambas manos, brazos extendidos hacia adelante.",
      "Mantén la espalda recta y el pecho elevado.",
      "Tira del agarre hacia el abdomen, llevando los codos hacia atrás y pegados al cuerpo.",
      "Contrae fuertemente los dorsales en la parte final del movimiento.",
      "Regresa lentamente a la posición inicial extendiendo los brazos con control.",
    ],
    muscles: ["Dorsal mayor", "Romboides", "Trapecio medio", "Deltoides posterior"],
    benefits: [
      "Desarrolla una espalda más ancha y gruesa.",
      "Mejora la postura y la estabilidad escapular.",
      "Aumenta la fuerza de tracción.",
      "Ideal para prevenir lesiones de hombro.",
    ],
    keys: [
      "Mantén la espalda recta en todo momento.",
      "Evita encorvar la espalda o mover el torso.",
    ],
    errors: [
      "Usar demasiado peso y balancearse.",
      "Encorvar la espalda.",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 12 REPETICIONES",
    rest: "45 - 60 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/p2hkv1z0_361331875_1783025413759901.mp4",
  },

  // ============== BÍCEPS ==============
  {
    id: "biceps-barra",
    name: "Bíceps con Barra",
    muscle_group: "biceps",
    equipment: "gym",
    tags: ["fuerza", "volumen", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/n8zqs842_file_00000000ed00722f8361b95b207081c1.png",
    execution: [
      "De pie, sostén la barra con un agarre supino a la anchura de los hombros.",
      "Mantén la espalda recta, el pecho elevado y los codos pegados al torso.",
      "Flexiona los codos llevando la barra hacia arriba, contrayendo los bíceps.",
      "Sube hasta que la barra esté cerca de los hombros y los bíceps completamente contraídos.",
      "Desciende lentamente a la posición inicial con control.",
      "Evita balanceos y movimientos del torso.",
    ],
    muscles: ["Bíceps braquial", "Braquial anterior", "Braquiorradial"],
    benefits: [
      "Aumenta la fuerza y el volumen de los bíceps.",
      "Mejora la definición del brazo.",
      "Fortalece la parte anterior del brazo.",
      "Permite trabajar con cargas altas para máximo desarrollo.",
    ],
    keys: [
      "Mantén los codos pegados al torso.",
      "No uses impulso ni balancees el cuerpo.",
    ],
    errors: [
      "Usar demasiado peso y balancearse.",
      "Mover los codos hacia adelante.",
      "No contraer los bíceps en la parte alta.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 12 REPETICIONES",
    rest: "45 - 60 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/g5e5kvwj_478522484_1783019691579083.mp4",
  },
  {
    id: "biceps-banco-mancuernas",
    name: "Bíceps en el Banco con Mancuernas",
    muscle_group: "biceps",
    equipment: "gym",
    tags: ["fuerza", "volumen", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/vwmgyuim_file_000000003b8471f5ab4952a77aa65c9d.png",
    execution: [
      "Siéntate en el banco con la espalda apoyada y los pies firmes en el suelo.",
      "Toma una mancuerna en cada mano con agarre neutro (palmas hacia adentro).",
      "Mantén los brazos extendidos junto a los muslos.",
      "Flexiona los codos llevando las mancuernas hacia los hombros, contrayendo los bíceps.",
      "Gira ligeramente las muñecas al final del movimiento (palmas hacia arriba).",
      "Baja las mancuernas de forma controlada hasta la posición inicial.",
      "Mantén el torso estable y evita balanceos.",
    ],
    muscles: ["Bíceps braquial", "Braquial anterior", "Braquiorradial", "Deltoides anterior (estabilizador)"],
    benefits: [
      "Aísla y desarrolla el bíceps de manera efectiva.",
      "Mejora la fuerza de agarre y la resistencia muscular.",
      "Aumenta el volumen y la definición del brazo.",
      "Menor estrés en la espalda al estar apoyado.",
      "Permite un rango de movimiento completo y controlado.",
    ],
    keys: [
      "Usa un peso que te permita mantener la técnica perfecta.",
      "No balancees el cuerpo ni uses impulso.",
      "Mantén los codos pegados a los lados.",
      "Contrae los bíceps en la parte alta del movimiento.",
      "Baja el peso de forma lenta y controlada.",
    ],
    errors: [
      "Usar demasiado peso y balancearse.",
      "Mover los codos hacia adelante.",
      "No contraer los bíceps al final del movimiento.",
      "Bajar las mancuernas demasiado rápido.",
      "Girar en exceso las muñecas desde el inicio.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 12 REPETICIONES",
    rest: "45 - 60 SEG",
  },
  {
    id: "biceps-martillo",
    name: "Bíceps Martillo (Hammer Curl)",
    muscle_group: "biceps",
    equipment: "gym",
    tags: ["fuerza", "volumen", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/fjd75dga_file_00000000a894722fb1167139245f2031.png",
    execution: [
      "Toma una mancuerna en cada mano con agarre neutro (pulgares hacia adelante).",
      "Mantén los brazos extendidos a los lados del cuerpo.",
      "Flexiona los codos levantando las mancuernas en línea recta hacia los hombros.",
      "Mantén el agarre neutro durante todo el movimiento.",
      "Contrae los bíceps en la parte superior del movimiento.",
      "Baja las mancuernas de forma controlada hasta la posición inicial.",
    ],
    muscles: ["Bíceps braquial", "Braquial anterior", "Braquiorradial", "Antebrazos", "Deltoides (estabilizador)"],
    benefits: [
      "Aumenta el grosor del bíceps y los brazos.",
      "Enfatiza el braquial y el braquiorradial.",
      "Mejora la fuerza de agarre y la resistencia del antebrazo.",
      "Menor estrés en las muñecas y hombros.",
      "Ideal para lograr un aspecto más completo del brazo.",
    ],
    keys: [
      "Mantén el core firme y la espalda recta.",
      "No balancees el cuerpo, evita usar impulso.",
      "Mantén los codos pegados al torso.",
      "Siente la contracción en los bíceps y antebrazos.",
      "Controla la fase excéntrica (al bajar).",
    ],
    errors: [
      "Usar demasiado impulso y balancearse.",
      "Abrir los codos hacia afuera.",
      "Girar las muñecas (perder el agarre neutro).",
      "Subir demasiado las mancuernas.",
      "Bajar las mancuernas demasiado rápido.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 15 REPETICIONES",
    rest: "45 - 60 SEG",
  },

  // ============== PECHO ==============
  {
    id: "press-banca",
    name: "Supino Reto con Barra",
    muscle_group: "chest",
    equipment: "gym",
    tags: ["fuerza", "volumen", "pecho completo"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/pihq7pjp_file_00000000752c722f8cfb552594d466a7.png",
    execution: [
      "Recuéstate en el banco plano con los pies firmes en el suelo.",
      "Sujeta la barra con las manos un poco más abiertas que los hombros.",
      "Retrae las escápulas y arquea ligeramente la espalda baja.",
      "Baja la barra controladamente hasta la línea media del pecho.",
      "Empuja la barra hacia arriba hasta extender los codos sin bloquearlos.",
      "Mantén los glúteos apoyados en el banco durante todo el movimiento.",
    ],
    muscles: ["Pectoral mayor", "Deltoides anterior", "Tríceps braquial"],
    benefits: [
      "Ejercicio fundamental para desarrollar masa muscular del pecho.",
      "Aumenta la fuerza de empuje del tren superior.",
      "Mejora la estabilidad escapular y la fuerza del core.",
      "Trabaja pecho, hombros y tríceps simultáneamente.",
    ],
    keys: [
      "Mantén las muñecas rectas y firmes.",
      "Los pies siempre en el suelo, glúteos en el banco.",
      "Baja la barra con control (2-3 segundos).",
    ],
    errors: [
      "Rebotar la barra sobre el pecho.",
      "Levantar los glúteos del banco.",
      "Bloquear los codos en la parte alta.",
    ],
    sets: "4 SERIES",
    reps: "6 - 10 REPETICIONES",
    rest: "90 - 120 SEG",
  },
  {
    id: "press-inclinado-mancuernas",
    name: "Supino Inclinado con Mancuernas",
    muscle_group: "chest",
    equipment: "gym",
    tags: ["pecho superior", "volumen", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/jk5kq7y6_file_00000000cd3c722f9fff551f80014511.png",
    execution: [
      "Ajusta el banco a una inclinación de 30-45 grados.",
      "Siéntate con una mancuerna en cada mano apoyada en los muslos.",
      "Recuéstate impulsando las mancuernas hasta la altura del pecho.",
      "Mantén los codos ligeramente por debajo de los hombros.",
      "Empuja las mancuernas hacia arriba, juntándolas ligeramente al final.",
      "Baja controladamente hasta sentir estiramiento en el pecho superior.",
    ],
    muscles: ["Pectoral mayor (fibras superiores)", "Deltoides anterior", "Tríceps braquial"],
    benefits: [
      "Enfatiza el desarrollo del pecho superior.",
      "Mejora la simetría y la forma del pectoral.",
      "Mayor rango de movimiento que la barra.",
      "Activa estabilizadores por el uso de mancuernas.",
    ],
    keys: [
      "No exagerar la inclinación (>45° involucra más hombro).",
      "Codos a 45° del torso, no abiertos a 90°.",
      "Controla la fase excéntrica.",
    ],
    errors: [
      "Inclinar demasiado el banco.",
      "Chocar las mancuernas con fuerza arriba.",
      "Bajar demasiado y forzar el hombro.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 12 REPETICIONES",
    rest: "60 - 90 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/crh1pnrg_lv_0_20260702201633.mp4",
  },
  {
    id: "press-inclinado-barra",
    name: "Supino Inclinado con Barra",
    muscle_group: "chest",
    equipment: "gym",
    tags: ["pecho superior", "fuerza", "compuesto"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/8r0g3k7v_file_00000000719c722f8bdac9dd4f913a84.png",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/x93w9526_download_20260702_200152_0000.mp4",
    execution: [
      "Ajusta el banco a una inclinación de 30-45 grados.",
      "Recuéstate en el banco con los pies firmes en el suelo y espalda apoyada.",
      "Sujeta la barra con las manos ligeramente más anchas que los hombros.",
      "Retracta las escápulas y saca la barra del soporte manteniendo los codos firmes.",
      "Baja la barra controladamente hasta la parte alta del pecho (clavículas).",
      "Empuja la barra hacia arriba en línea recta, contrayendo el pecho superior.",
      "Extiende los codos sin bloquearlos por completo al final del movimiento.",
    ],
    muscles: [
      "Pectoral mayor (fibras superiores)",
      "Deltoides anterior",
      "Tríceps braquial",
      "Serrato anterior (estabilizador)",
    ],
    benefits: [
      "El mejor ejercicio para el pecho superior (fibras claviculares).",
      "Permite mover cargas altas y ganar fuerza real.",
      "Crea la forma de pecho tipo 'shelf' que da el look estético.",
      "Involucra hombros y tríceps como apoyo secundario.",
    ],
    keys: [
      "Inclinación del banco entre 30° y 45° (no más).",
      "Escápulas retraídas y espalda pegada al banco.",
      "Barra baja hacia la clavícula, no hacia el mentón.",
      "Codos a 45° del torso, no completamente abiertos.",
    ],
    errors: [
      "Inclinación mayor a 45° (convierte el ejercicio en press militar).",
      "Rebotar la barra en el pecho.",
      "Levantar los glúteos del banco para hacer palanca.",
      "Bloquear los codos violentamente arriba.",
    ],
    sets: "4 SERIES",
    reps: "6 - 10 REPETICIONES",
    rest: "90 - 120 SEG",
  },
  {
    id: "aperturas-mancuernas",
    name: "Apertura en Banco con Mancuernas",
    muscle_group: "chest",
    equipment: "gym",
    tags: ["aislamiento", "definición", "estiramiento"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/s9e4wgtx_file_00000000417471f5aae4bc95b84a6691.png",
    execution: [
      "Recuéstate en un banco plano con una mancuerna en cada mano.",
      "Extiende los brazos hacia arriba con las palmas enfrentadas.",
      "Mantén una ligera flexión en los codos (nunca rectos).",
      "Baja los brazos abriéndolos en arco hasta la altura del pecho.",
      "Siente el estiramiento en el pectoral en la posición baja.",
      "Vuelve al inicio contrayendo el pecho, siguiendo la misma trayectoria.",
    ],
    muscles: ["Pectoral mayor", "Deltoides anterior (estabilizador)"],
    benefits: [
      "Aísla completamente el pectoral.",
      "Mejora la flexibilidad del pecho y hombros.",
      "Excelente para definición y forma.",
      "Complemento perfecto de los presses.",
    ],
    keys: [
      "Codos ligeramente flexionados y FIJOS.",
      "Movimiento en arco, no de press.",
      "Usa pesos moderados, prioriza la técnica.",
    ],
    errors: [
      "Extender totalmente los codos (riesgo de lesión).",
      "Bajar demasiado los brazos.",
      "Usar demasiado peso.",
    ],
    sets: "3 SERIES",
    reps: "10 - 15 REPETICIONES",
    rest: "45 - 60 SEG",
  },
  {
    id: "pec-deck",
    name: "Aperturas en Máquina (Pec Deck)",
    muscle_group: "chest",
    equipment: "gym",
    tags: ["aislamiento", "definición", "pectoral mayor"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/dlhjxgke_file_00000000c2ec720ca916aa19e6c3e321.png",
    execution: [
      "Siéntate en la máquina con la espalda completamente apoyada en el respaldo.",
      "Ajusta la altura del asiento para que los brazos queden a la altura del pecho.",
      "Sujeta las manijas con los brazos abiertos y ligera flexión de codos.",
      "Junta las manijas en un movimiento controlado hacia el centro del cuerpo.",
      "Contrae el pectoral en el punto máximo del movimiento por 1 segundo.",
      "Regresa lentamente a la posición inicial sin perder la tensión.",
    ],
    muscles: ["Pectoral mayor", "Deltoides anterior (estabilizador)"],
    benefits: [
      "Aísla completamente el pectoral mayor.",
      "Excelente para definición y forma del pecho.",
      "Movimiento seguro y controlado (ideal para principiantes).",
      "Menor estrés en articulaciones vs. mancuernas.",
    ],
    keys: [
      "Codos ligeramente flexionados y FIJOS.",
      "Espalda pegada al respaldo en todo momento.",
      "Contracción máxima en el centro.",
    ],
    errors: [
      "Extender totalmente los codos (riesgo de lesión).",
      "Despegar la espalda del respaldo.",
      "Usar demasiado peso y perder rango de movimiento.",
    ],
    sets: "3 - 4 SERIES",
    reps: "12 - 15 REPETICIONES",
    rest: "45 - 60 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/5ecdka9t_download_20260702_200858_0000.mp4",
  },

  // ============== HOMBROS ==============
  {
    id: "desarrollo-militar-mancuernas",
    name: "Desarrollo Militar con Mancuernas",
    muscle_group: "shoulders",
    equipment: "gym",
    tags: ["deltoides anterior", "volumen", "fuerza"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/1ezeyxaf_file_0000000095c8722fb0cca65399d90284.png",
    execution: [
      "Sentado con la espalda apoyada, una mancuerna en cada mano a la altura de los hombros.",
      "Palmas al frente, codos ligeramente por delante del torso.",
      "Empuja las mancuernas hacia arriba hasta extender completamente los brazos.",
      "Contrae los hombros en la parte alta del movimiento por 1 segundo.",
      "Baja las mancuernas de forma controlada hasta la posición inicial.",
      "Mantén el core activado y no uses impulso.",
    ],
    muscles: ["Deltoides anterior (principal)", "Deltoides medio (asistencia)", "Tríceps", "Trapecio superior (estabilizador)"],
    benefits: [
      "Desarrolla masa y fuerza del deltoides anterior.",
      "Mayor rango de movimiento que con barra.",
      "Activa estabilizadores por el uso de mancuernas independientes.",
      "Excelente para simetría de hombros.",
    ],
    keys: [
      "Mantén el core firme durante todo el movimiento.",
      "No arquees la espalda baja.",
      "Enfócate en el deltoides, no en el ego.",
      "Usa un peso que te permita técnica perfecta.",
    ],
    errors: [
      "Usar impulso o balancearse hacia atrás.",
      "Extender exageradamente la espalda.",
      "Bajar las mancuernas muy rápido.",
      "Cerrar los ojos o perder la postura.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 12 REPETICIONES",
    rest: "60 - 90 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/3h4s5gok_lv_0_20260703174914.mp4",
  },
  {
    id: "elevacion-frontal",
    name: "Elevación Frontal con Mancuernas",
    muscle_group: "shoulders",
    equipment: "gym",
    tags: ["deltoides anterior", "aislamiento", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/y4zpay1y_file_0000000070f8720cb41c8dee30e107ec.png",
    execution: [
      "De pie, con una mancuerna en cada mano al frente de los muslos.",
      "Espalda recta, pecho abierto y core activado.",
      "Eleva los brazos hacia adelante hasta la altura de los hombros.",
      "Mantén una ligera flexión en los codos.",
      "Contrae el deltoides anterior por un momento.",
      "Baja las mancuernas de forma lenta y controlada hasta la posición inicial.",
    ],
    muscles: ["Deltoides anterior (parte frontal del hombro)"],
    benefits: [
      "Aísla completamente la parte frontal del hombro.",
      "Excelente para definición y forma del deltoides anterior.",
      "Complementa los presses de hombro y pecho.",
      "Mejora la estética del hombro visto de frente.",
    ],
    keys: [
      "Mantén el torso estable y evita balancearte.",
      "No subas más allá de la altura de los hombros.",
      "Enfócate en el deltoides anterior, no en el peso.",
      "Controla la bajada para mayor activación muscular.",
    ],
    errors: [
      "Usar impulso o balancear el torso.",
      "Subir más allá de la altura de los hombros.",
      "Usar demasiado peso y perder la técnica.",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 15 REPETICIONES",
    rest: "60 - 90 SEG",
  },
  {
    id: "rear-delt-fly-machine",
    name: "Posterior de Shoulder en el Fly (Máquina)",
    muscle_group: "shoulders",
    equipment: "gym",
    tags: ["deltoides posterior", "estabilidad", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/ugykheix_file_000000009720720cae8380b55a9419c2.png",
    execution: [
      "Siéntate en la máquina y ajusta el pecho contra el soporte.",
      "Toma las manijas con agarre neutro (pulgares enfrentados).",
      "Mantén una ligera flexión en los codos.",
      "Abre los brazos hacia los lados llevando los codos hacia atrás.",
      "Contrae los deltoides posteriores en la parte final del movimiento.",
      "Regresa lentamente a la posición inicial con control.",
      "Mantén el torso fijo y evita balancearte.",
    ],
    muscles: ["Deltoides posterior", "Trapecio medio e inferior", "Romboides", "Infraespinoso", "Redondo menor"],
    benefits: [
      "Aísla y desarrolla el deltoides posterior.",
      "Mejora la postura y la estabilidad escapular.",
      "Equilibra el desarrollo de los hombros.",
      "Aporta definición y separación en la parte trasera del hombro.",
      "Reduce el riesgo de lesiones en el hombro.",
    ],
    keys: [
      "Mantén el pecho apoyado y la espalda firme.",
      "Usa un movimiento controlado y sin impulso.",
      "Lleva los codos hacia atrás, no solo las manos.",
      "Enfócate en la contracción del deltoides posterior.",
      "Exhala al abrir los brazos, inhala al regresar.",
    ],
    errors: [
      "Usar demasiado peso e impulsarse.",
      "Elevar los hombros hacia las orejas.",
      "Mover solo los antebrazos, sin activar la espalda.",
      "No contraer al final del movimiento.",
      "Arquear la espalda o despegar el pecho del soporte.",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 15 REPETICIONES",
    rest: "45 - 60 SEG",
  },
  {
    id: "encogimiento-trapecio",
    name: "Encogimiento de Trapecio con Mancuernas",
    muscle_group: "shoulders",
    equipment: "gym",
    tags: ["trapecio superior", "grosor", "estabilidad"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/9j6k5hzu_file_00000000a40471f5bcd3dd0df685d0ce.png",
    execution: [
      "De pie, con una mancuerna en cada mano a los lados del cuerpo.",
      "Brazos completamente extendidos y hombros en posición neutra.",
      "Eleva los hombros hacia arriba, encogiendo los trapecios lo más posible.",
      "Mantén la contracción en la parte alta por 1-2 segundos.",
      "Baja los hombros de forma controlada hasta la posición inicial.",
      "No uses impulso, el movimiento debe ser lento y controlado.",
    ],
    muscles: ["Trapecio superior"],
    benefits: [
      "Desarrolla grosor del trapecio superior.",
      "Aumenta el aspecto voluminoso del cuello y hombros.",
      "Fortalece la estabilidad de la cintura escapular.",
      "Mejora la postura general.",
    ],
    keys: [
      "Mantén la espalda recta y el core activado.",
      "No balancees el cuerpo ni uses impulso.",
      "Enfócate en encoger los hombros hacia arriba, no hacia adelante.",
      "Baja lentamente para mayor activación.",
      "Usa un peso que te permita una técnica perfecta.",
    ],
    errors: [
      "Usar impulso o balancear el cuerpo.",
      "Elevar los hombros hacia adelante en lugar de hacia arriba.",
      "No hacer una contracción completa.",
      "Bajar los hombros demasiado rápido.",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 15 REPETICIONES",
    rest: "45 - 60 SEG",
  },
  {
    id: "press-militar",
    name: "Press Militar con Barra",
    muscle_group: "shoulders",
    equipment: "gym",
    tags: ["fuerza", "volumen", "hombros completos"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/2rlehnrv_Pressmilitar.png",
    execution: [
      "De pie o sentado, sostén la barra a la altura de los hombros.",
      "Agarre ligeramente más abierto que los hombros, palmas hacia adelante.",
      "Contrae el core y mantén la espalda neutra.",
      "Empuja la barra hacia arriba hasta extender los brazos sobre la cabeza.",
      "Evita hiperextender la espalda baja.",
      "Baja controladamente hasta la altura de la barbilla o clavículas.",
    ],
    muscles: ["Deltoides (anterior y medio)", "Trapecio", "Tríceps braquial"],
    benefits: [
      "Ejercicio compuesto rey para hombros.",
      "Aumenta fuerza y tamaño del deltoides.",
      "Mejora la estabilidad del core y postura.",
      "Fortalece toda la cadena de empuje vertical.",
    ],
    keys: [
      "Aprieta glúteos y core para estabilizar.",
      "Barra sube en línea recta sobre la cabeza.",
      "No trabes los codos arriba.",
    ],
    errors: [
      "Arquear excesivamente la espalda baja.",
      "Empujar la barra hacia adelante en lugar de arriba.",
      "Usar impulso de piernas (a menos que sea push press).",
    ],
    sets: "4 SERIES",
    reps: "6 - 10 REPETICIONES",
    rest: "90 - 120 SEG",
  },
  {
    id: "elevaciones-laterales",
    name: "Elevaciones Laterales",
    muscle_group: "shoulders",
    equipment: "gym",
    tags: ["aislamiento", "amplitud", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/fafq6h9n_file_0000000012e871f591df8ada0ea942f8.png",
    execution: [
      "De pie con una mancuerna en cada mano a los costados.",
      "Espalda recta, ligera flexión en los codos.",
      "Eleva los brazos hacia los lados hasta la altura de los hombros.",
      "Las palmas miran ligeramente hacia el suelo (pulgar hacia abajo).",
      "Contrae en el punto más alto por 1 segundo.",
      "Baja lentamente controlando el peso.",
    ],
    muscles: ["Deltoides medio", "Trapecio (fibras superiores)"],
    benefits: [
      "Da amplitud y forma de V al torso.",
      "Aísla completamente el deltoides medio.",
      "Mejora la simetría de los hombros.",
      "Fortalece el rango de movimiento lateral.",
    ],
    keys: [
      "Prioriza técnica sobre peso.",
      "Sube los brazos guiando con los codos.",
      "No pases de la altura de los hombros.",
    ],
    errors: [
      "Usar demasiado peso y balancearse.",
      "Encoger los trapecios.",
      "Subir por encima de los hombros.",
    ],
    sets: "3 - 4 SERIES",
    reps: "12 - 15 REPETICIONES",
    rest: "45 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/kphcas3r_lv_0_20260703175130.mp4",
  },
  {
    id: "pajaros-mancuernas",
    name: "Pájaros con Mancuernas (Rear Delt Fly)",
    muscle_group: "shoulders",
    equipment: "gym",
    tags: ["hombro posterior", "postura", "detalle"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/pvwii6u4_Pajjaro.png",
    execution: [
      "De pie, inclinado hacia adelante con espalda recta a 45°.",
      "Mancuernas colgando debajo del pecho, palmas enfrentadas.",
      "Eleva las mancuernas hacia los lados en arco.",
      "Aprieta las escápulas al llegar arriba.",
      "Mantén los codos ligeramente flexionados y fijos.",
      "Regresa a la posición inicial con control.",
    ],
    muscles: ["Deltoides posterior", "Romboides", "Trapecio medio"],
    benefits: [
      "Fortalece la parte trasera del hombro (a menudo débil).",
      "Mejora significativamente la postura.",
      "Previene lesiones de hombro.",
      "Equilibra el desarrollo de los deltoides.",
    ],
    keys: [
      "Espalda recta, no encorvada.",
      "Movimiento en arco, aprieta escápulas.",
      "Usa peso ligero-moderado.",
    ],
    errors: [
      "Encorvar la espalda.",
      "Levantar el torso al subir el peso.",
      "Usar demasiado peso y perder técnica.",
    ],
    sets: "3 SERIES",
    reps: "12 - 15 REPETICIONES",
    rest: "45 SEG",
  },

  // ============== PIERNAS ==============
  {
    id: "sentadilla-barra",
    name: "Sentadilla con Barra",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["rey de piernas", "fuerza", "volumen"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/9d9064pd_file_00000000fc4871f5973c6a792b85f260.png",
    execution: [
      "Coloca la barra sobre los trapecios (no sobre el cuello).",
      "Pies a la anchura de los hombros, puntas ligeramente hacia afuera.",
      "Contrae el core, pecho arriba, mirada al frente.",
      "Baja flexionando caderas y rodillas simultáneamente.",
      "Desciende hasta que los muslos queden paralelos al suelo o más abajo.",
      "Sube empujando desde los talones, extendiendo caderas y rodillas.",
    ],
    muscles: ["Cuádriceps", "Glúteo mayor", "Isquiotibiales", "Core"],
    benefits: [
      "Ejercicio más completo para el tren inferior.",
      "Aumenta fuerza y masa muscular general.",
      "Mejora la movilidad de tobillos y caderas.",
      "Estimula hormonas anabólicas por su intensidad.",
    ],
    keys: [
      "Rodillas alineadas con la punta de los pies.",
      "Espalda neutra durante todo el movimiento.",
      "Baja controlado, sube explosivo.",
    ],
    errors: [
      "Colapsar las rodillas hacia adentro.",
      "Redondear la espalda baja.",
      "Levantar los talones del suelo.",
    ],
    sets: "4 - 5 SERIES",
    reps: "6 - 10 REPETICIONES",
    rest: "2 - 3 MIN",
  },
  {
    id: "peso-muerto-rumano",
    name: "Stiff con Mancuernas",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["isquiotibiales", "glúteos", "cadena posterior"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/vcyo351l_file_0000000010ec720c903d6c919c98f5f2.png",
    execution: [
      "De pie con los pies a la altura de las caderas, una mancuerna en cada mano frente a los muslos.",
      "Espalda recta, pecho alto y rodillas ligeramente flexionadas.",
      "Empuja la cadera hacia atrás como si cerraras una puerta con el trasero.",
      "Inclina el torso hacia adelante manteniendo la espalda recta y las mancuernas deslizándose cerca de las piernas.",
      "Desciende hasta sentir un fuerte estiramiento en los isquiotibiales.",
      "Extiende la cadera empujando los glúteos hacia adelante para volver a la posición inicial de forma controlada.",
      "No hiperextiendas la espalda al subir.",
    ],
    muscles: ["Isquiotibiales (biceps femoral, semitendinoso, semimembranoso)", "Glúteo mayor (porción inferior)", "Erectores espinales (estabilizadores)"],
    benefits: [
      "Fortalece y aísla los isquiotibiales.",
      "Mejora la postura y la estabilidad de la cadena posterior.",
      "Aumenta la fuerza en peso muerto y otros ejercicios compuestos.",
      "Ayuda a prevenir lesiones en la parte posterior del muslo.",
    ],
    keys: [
      "Mantén la espalda recta siempre.",
      "Siente el estiramiento en los isquiotibiales.",
      "Empuja la cadera hacia atrás, no te sientes.",
      "Mantén las mancuernas cerca del cuerpo.",
      "Controla el movimiento en todo momento.",
    ],
    errors: [
      "Redondear la espalda.",
      "Doblar demasiado las rodillas.",
      "Alejar las mancuernas del cuerpo.",
      "Usar demasiado peso y perder la técnica.",
      "Hiperextender la espalda al subir.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 12 REPETICIONES",
    rest: "60 - 90 SEG",
  },
  {
    id: "stiff-unilateral",
    name: "Stiff Unilateral con Mancuernas",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["unilateral", "equilibrio", "cadena posterior"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/3vklu2xe_file_00000000e1b071f5a6bc5cd02c8142c7.png",
    execution: [
      "De pie con una mancuerna en una mano, pies al ancho de la cadera.",
      "Activa el core y mantén la espalda recta, hombros hacia atrás y abajo.",
      "Empuja la cadera hacia atrás e inclina el torso hacia adelante manteniendo la espalda recta.",
      "Extiende la pierna contraria hacia atrás, alineada con el torso.",
      "Pierna de apoyo con ligera flexión de rodilla, mancuerna cerca de la pierna.",
      "Siente el estiramiento en isquiotibiales y glúteos, sin redondear la espalda.",
      "Contrae isquiotibiales y glúteos para volver a la posición inicial empujando la cadera hacia adelante.",
      "Mantén el equilibrio y el control durante todo el movimiento.",
    ],
    muscles: ["Isquiotibiales (biceps femoral, semitendinoso, semimembranoso)", "Glúteo mayor", "Erectores espinales (estabilizadores)", "Core y músculos estabilizadores de la cadera"],
    benefits: [
      "Aumenta la fuerza y masa en isquiotibiales y glúteos.",
      "Mejora el equilibrio, la coordinación y la estabilidad.",
      "Ayuda a prevenir lesiones en la cadena posterior.",
      "Mejora el rendimiento deportivo y funcional.",
      "Corrige asimetrías entre lados.",
    ],
    keys: [
      "Mantén la espalda recta.",
      "Hinge (dobla) desde la cadera, no desde la cintura.",
      "Siente el estiramiento en los isquiotibiales.",
      "Mantén la cadera cuadrada (no la dejes rotar).",
      "Controla el movimiento en todo momento.",
    ],
    errors: [
      "Redondear la espalda.",
      "Flexionar demasiado la rodilla.",
      "Dejar caer la cadera o rotarla.",
      "Usar demasiado peso y perder la técnica.",
      "No sentir el trabajo en los isquiotibiales.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 12 POR PIERNA",
    rest: "60 - 90 SEG",
  },
  {
    id: "prensa-piernas",
    name: "Prensa de Piernas",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["volumen", "seguridad", "cuádriceps"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/nlgrrej8_file_000000009d0c71f585b52b56fc6e437e.png",
    execution: [
      "Siéntate en la prensa con la espalda completamente apoyada.",
      "Coloca los pies a la anchura de los hombros en la plataforma.",
      "Desbloquea el seguro y sostén la plataforma con las piernas.",
      "Baja controladamente flexionando las rodillas hacia el pecho.",
      "Detente cuando las rodillas formen un ángulo de 90°.",
      "Empuja la plataforma hacia arriba sin bloquear las rodillas al final.",
    ],
    muscles: ["Cuádriceps", "Glúteo mayor", "Isquiotibiales"],
    benefits: [
      "Permite mover cargas altas de forma segura.",
      "Aísla el tren inferior sin estrés lumbar.",
      "Ideal para hipertrofia de cuádriceps.",
      "Excelente alternativa cuando la sentadilla no es viable.",
    ],
    keys: [
      "No bloquees las rodillas al extender.",
      "Baja lento (2-3 segundos), sube controlado.",
      "Espalda baja siempre pegada al respaldo.",
    ],
    errors: [
      "Bajar demasiado y despegar la espalda baja.",
      "Colapsar las rodillas hacia adentro.",
      "Bloquear las rodillas en la parte alta.",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 15 REPETICIONES",
    rest: "60 - 90 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/keg14ysu_lv_0_20260702183854.mp4",
  },
  {
    id: "hack-squat",
    name: "Hack Squat",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["cuádriceps", "volumen", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/5y6wrrk7_file_00000000b77c71f59e52948206c72c6f.png",
    execution: [
      "Colócate en la máquina Hack Squat con los hombros apoyados en las almohadillas.",
      "Espalda completamente pegada al respaldo, pies a la anchura de los hombros.",
      "Desbloquea el seguro sosteniendo el peso con las piernas.",
      "Baja flexionando las rodillas hasta que los muslos estén paralelos al suelo.",
      "Empuja con los talones y la parte media del pie para subir.",
      "Extiende las piernas sin bloquear las rodillas al final del movimiento.",
    ],
    muscles: ["Cuádriceps (vasto medial, lateral y externo)", "Glúteo mayor", "Isquiotibiales"],
    benefits: [
      "Aísla el cuádriceps de forma segura y efectiva.",
      "Permite cargas altas con menor riesgo lumbar.",
      "Excelente para hipertrofia y volumen de piernas.",
      "Trayectoria fija que permite enfocar la técnica.",
    ],
    keys: [
      "Espalda pegada al respaldo en todo momento.",
      "Rodillas alineadas con la punta de los pies.",
      "Baja controlado, sube explosivo.",
    ],
    errors: [
      "Colapsar las rodillas hacia adentro.",
      "Despegar la cadera del respaldo.",
      "Bloquear las rodillas en la extensión.",
    ],
    sets: "4 SERIES",
    reps: "8 - 12 REPETICIONES",
    rest: "90 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/wafkgufx_gemini_generated_video_7ff22be0.mp4",
  },
  {
    id: "leg-extension",
    name: "Extensión de Cuádriceps (Leg Extension)",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["aislamiento", "cuádriceps", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/6kl5umc4_file_00000000031c71f58b6f43efe311b9be.png",
    execution: [
      "Siéntate en la máquina con la espalda completamente apoyada en el respaldo.",
      "Ajusta el rodillo para que quede en los tobillos, justo encima de los pies.",
      "Sujeta las manijas laterales para estabilizar el torso.",
      "Extiende las piernas hacia arriba hasta que queden completamente rectas.",
      "Contrae el cuádriceps en la parte alta del movimiento por 1 segundo.",
      "Baja lentamente controlando el peso hasta la posición inicial.",
    ],
    muscles: ["Cuádriceps (vasto medial, vasto lateral, vasto intermedio, recto femoral)"],
    benefits: [
      "Aísla completamente el cuádriceps.",
      "Excelente para definición y forma del muslo.",
      "Fortalece la rodilla y estabiliza la articulación.",
      "Ideal como ejercicio de finalización o pre-fatiga.",
    ],
    keys: [
      "Contrae el cuádriceps en la parte alta.",
      "Movimiento controlado en ambas fases.",
      "Espalda pegada al respaldo, no arquear.",
    ],
    errors: [
      "Usar impulso balanceando el torso.",
      "Bajar el peso demasiado rápido.",
      "No completar el rango de movimiento.",
    ],
    sets: "3 - 4 SERIES",
    reps: "12 - 15 REPETICIONES",
    rest: "45 - 60 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/3ac7j5ox_gemini_generated_video_8897324e.mp4",
  },
  {
    id: "zancadas-mancuernas",
    name: "Zancadas con Mancuernas",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["unilateral", "glúteos", "cuádriceps"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/jxxr554t_file_00000000e95871f795ba7d4d79ed5f34.png",
    execution: [
      "De pie con una mancuerna en cada mano a los lados del cuerpo.",
      "Da un paso largo hacia adelante con una pierna.",
      "Baja el cuerpo flexionando ambas rodillas a 90°.",
      "La rodilla trasera debe casi tocar el suelo sin apoyarse.",
      "Mantén el torso erguido y el core activado.",
      "Empuja con el talón delantero para volver a la posición inicial.",
      "Alterna piernas o completa todas las repeticiones con una antes de cambiar.",
    ],
    muscles: ["Cuádriceps", "Glúteo mayor", "Isquiotibiales", "Aductores", "Core (estabilizador)"],
    benefits: [
      "Trabaja cada pierna de forma independiente (corrige asimetrías).",
      "Excelente para forma y definición de glúteos.",
      "Mejora el equilibrio y la coordinación.",
      "Activa muchos músculos estabilizadores.",
    ],
    keys: [
      "Torso erguido, core activado.",
      "Paso lo suficientemente largo para 90° en ambas rodillas.",
      "Empuja con el talón de la pierna delantera.",
    ],
    errors: [
      "Inclinar el torso hacia adelante.",
      "Rodilla delantera pasando la punta del pie.",
      "Paso demasiado corto (estrés en rodilla).",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 12 POR PIERNA",
    rest: "60 - 90 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/m0nuqpue_download_20260702_185143_0000.mp4",
  },

  // Nuevo ejercicio con video: Mesa Flexora / Curl Femoral
  {
    id: "mesa-flexora",
    name: "Mesa Flexora (Curl Femoral Acostado)",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["aislamiento", "isquiotibiales", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/2ew7hy52_file_00000000e0a871f584f33237a6b10708.png",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/p3pci3me_lv_0_20260702180427.mp4",
    execution: [
      "Acuéstate boca abajo en la máquina con las rodillas justo debajo del borde del acolchado.",
      "Ajusta el rodillo para que quede sobre los tendones de Aquiles (parte baja de la pantorrilla).",
      "Sujeta las manijas laterales y mantén la cadera pegada al banco durante todo el movimiento.",
      "Flexiona las rodillas llevando los talones hacia los glúteos.",
      "Contrae los isquiotibiales en la parte alta por 1 segundo.",
      "Baja lentamente controlando la fase excéntrica hasta la posición inicial.",
    ],
    muscles: [
      "Isquiotibiales (bíceps femoral, semitendinoso, semimembranoso)",
      "Gastrocnemios (gemelos, secundarios)",
      "Glúteo mayor (asistencia leve)",
    ],
    benefits: [
      "Aísla completamente los isquiotibiales.",
      "Corrige desbalance músculos anteriores/posteriores del muslo.",
      "Mejora la definición y forma de la parte posterior del muslo.",
      "Protege la rodilla al fortalecer los estabilizadores.",
    ],
    keys: [
      "Cadera pegada al banco (no levantar la pelvis).",
      "Rango completo: estira abajo, contrae arriba.",
      "Controla la fase excéntrica (2 segundos bajando).",
    ],
    errors: [
      "Despegar la cadera para usar impulso.",
      "Hiperextender la zona lumbar.",
      "Usar momentum en lugar de contracción muscular.",
    ],
    sets: "3 - 5 SERIES",
    reps: "8 - 15 REPETICIONES",
    rest: "60 - 90 SEG",
  },

  // ============== HIP THRUST (GLÚTEOS) ==============
  {
    id: "hip-thrust",
    name: "Hip Thrust con Barra",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["glúteos", "hipertrofia", "compuesto"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/n9o1x1k8_file_00000000bb18722f86bad2ee386ad39d.png",
    execution: [
      "Apoya la parte alta de tu espalda en un banco.",
      "Pies al ancho de los hombros, rodillas flexionadas a 90°.",
      "Coloca la barra sobre la cadera (usa almohadilla para comodidad).",
      "Activa el core y empuja a través de los talones.",
      "Eleva la cadera hasta alinear hombros, caderas y rodillas.",
      "Contrae los glúteos en la parte alta durante 1-2 segundos.",
      "Baja la cadera de forma controlada hasta la posición inicial sin tocar el suelo.",
    ],
    muscles: [
      "Glúteo mayor (principal)",
      "Isquiotibiales",
      "Aductores",
      "Erectores espinales",
      "Core",
    ],
    benefits: [
      "El mejor ejercicio para hipertrofia de glúteos.",
      "Permite mover cargas altas de forma segura.",
      "Mejora la forma y proyección del glúteo.",
      "Aumenta fuerza real de cadera transferible a sentadillas y peso muerto.",
    ],
    keys: [
      "Mentón ligeramente recogido durante todo el movimiento.",
      "No dejes que las rodillas se cierren hacia adentro.",
      "Barra descansa sobre la cadera, no sobre el abdomen.",
      "Enfócate en sentir el trabajo en los glúteos, no en los muslos.",
    ],
    errors: [
      "Hiperextender la espalda baja en la parte alta.",
      "Rodillas colapsando hacia adentro.",
      "Usar carga excesiva sacrificando técnica.",
      "Bajar demasiado y tocar el suelo (pierdes tensión).",
    ],
    sets: "3 - 5 SERIES",
    reps: "8 - 12 REPETICIONES",
    rest: "90 - 120 SEG",
  },

  // ============== ABDUCTORA (GLÚTEO MEDIO) ==============
  {
    id: "abductora-maquina",
    name: "Abductora en Máquina",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["glúteo medio", "abductores", "aislamiento"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/1olfm6j0_file_000000008f1c71f5bdaf8d00ac99891d.png",
    execution: [
      "Siéntate en la máquina y coloca las piernas contra los pads exteriores.",
      "Ajusta el asiento y las manijas para mantener la espalda pegada al respaldo.",
      "Empuja hacia afuera separando las piernas contrayendo los glúteos.",
      "Mantén la contracción en el punto máximo durante 1 segundo.",
      "Regresa lentamente a la posición inicial controlando el movimiento.",
      "Enfócate en sentir la activación del glúteo medio en cada repetición.",
    ],
    muscles: [
      "Glúteo medio (principal)",
      "Glúteo menor",
      "Tensor de la fascia lata",
      "Glúteo mayor (fibras superiores, secundario)",
    ],
    benefits: [
      "El mejor ejercicio para aislar el glúteo medio.",
      "Mejora la forma lateral del glúteo (efecto 'shelf').",
      "Estabiliza la cadera y previene lesiones de rodilla.",
      "Corrige desbalances entre glúteo mayor y estabilizadores.",
      "Complementa perfectamente sentadillas y hip thrust.",
    ],
    keys: [
      "Movimiento controlado, sin usar impulso.",
      "Contracción completa al abrir las piernas.",
      "Fase excéntrica de 2 segundos al cerrar.",
      "Ligera inclinación hacia adelante activa más el glúteo medio.",
    ],
    errors: [
      "Usar impulso balanceando el torso.",
      "Rango de movimiento incompleto.",
      "Levantar los glúteos del asiento.",
      "Sacrificar técnica por peso.",
    ],
    sets: "3 - 4 SERIES",
    reps: "12 - 20 REPETICIONES",
    rest: "45 - 60 SEG",
  },

  // ============== ADUCTORA (INTERIOR MUSLO) ==============
  {
    id: "aductora-maquina",
    name: "Aductora en Máquina",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["aductores", "muslo interior", "aislamiento"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/u8y794gd_file_00000000605471f787a0e89884b68d2d.png",
    execution: [
      "Siéntate en la máquina y coloca las piernas contra los pads internos.",
      "Ajusta la abertura inicial cómoda pero exigente (no exageres el estiramiento).",
      "Sujeta las manijas laterales y mantén la espalda recta contra el respaldo.",
      "Junta las piernas contrayendo los aductores del muslo interior.",
      "Mantén la contracción en el centro durante 1 segundo.",
      "Regresa lentamente a la posición inicial controlando la fase excéntrica.",
    ],
    muscles: [
      "Aductor mayor (principal)",
      "Aductor corto",
      "Aductor largo",
      "Grácil",
      "Pectíneo",
    ],
    benefits: [
      "Aísla completamente los aductores (parte interna del muslo).",
      "Complemento perfecto de la abductora para balance muscular.",
      "Estabiliza la cadera y mejora la técnica en sentadilla.",
      "Reduce riesgo de lesiones inguinales.",
      "Rellena la parte interna del muslo (efecto de piernas gruesas).",
    ],
    keys: [
      "Movimiento controlado, sin usar impulso.",
      "Contracción completa al juntar las piernas.",
      "Fase excéntrica de 2 segundos al abrir.",
      "Espalda pegada al respaldo durante todo el movimiento.",
    ],
    errors: [
      "Usar impulso balanceando el torso.",
      "Rango de movimiento incompleto.",
      "Sobre-estirar en la posición inicial (riesgo de lesión).",
      "Levantar los glúteos del asiento.",
    ],
    sets: "3 - 4 SERIES",
    reps: "12 - 20 REPETICIONES",
    rest: "45 - 60 SEG",
  },

  {
    id: "pantorrilla-sentada",
    name: "Pantorrilla Sentada (Sóleo)",
    muscle_group: "legs",
    equipment: "gym",
    tags: ["pantorrillas", "sóleo", "aislamiento"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/10ingrg4_file_00000000ebc871f5a830938329275634.png",
    execution: [
      "Siéntate en la máquina y coloca las puntas de los pies en el borde del soporte.",
      "Ajusta el rodillo sobre tus muslos, justo por encima de las rodillas.",
      "Mantén la espalda recta y los pies alineados.",
      "Eleva los talones lo más alto posible contrayendo las pantorrillas.",
      "Mantén la contracción en la parte alta durante 1 segundo.",
      "Baja lentamente los talones hasta sentir un buen estiramiento.",
      "No dejes que los talones toquen completamente el suelo. Repite.",
    ],
    muscles: [
      "Sóleo (principal, se activa con rodilla flexionada)",
      "Gastrocnemios (gemelos, secundarios)",
    ],
    benefits: [
      "Único ejercicio que aísla el sóleo eficazmente.",
      "Complementa las elevaciones de pantorrilla de pie.",
      "Mejora la forma y volumen inferior de la pantorrilla.",
      "Aumenta rendimiento en carreras, saltos y sprints.",
    ],
    keys: [
      "Enfócate en la contracción y en el estiramiento completo.",
      "Controla la velocidad del movimiento, no uses impulso.",
      "Usa un peso que te permita mantener buena técnica.",
      "Mantén las puntas en el borde del soporte durante todo el ejercicio.",
    ],
    errors: [
      "Usar impulso y rebotar la carga.",
      "Rango de movimiento incompleto (solo la mitad del recorrido).",
      "Descargar los talones apoyándolos en el suelo.",
    ],
    sets: "3 - 5 SERIES",
    reps: "10 - 20 REPETICIONES",
    rest: "45 - 60 SEG",
  },


  // ============== TRÍCEPS ==============
  {
    id: "triceps-cable-supino",
    name: "Tríceps al Revés en Cable (Agarre Supino)",
    muscle_group: "triceps",
    equipment: "gym",
    tags: ["fuerza", "control", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/resdo0ic_file_00000000de44722fa3e7f816e08aebb4.png",
    execution: [
      "Sujeta la barra con un agarre supino (palmas hacia arriba).",
      "Mantén los codos pegados al cuerpo y flexionados a 90°.",
      "Extiende los brazos empujando la barra hacia abajo, enfocándote en contraer el tríceps.",
      "Mantén los codos fijos durante todo el movimiento.",
      "Contrae el tríceps al final del movimiento, con los brazos completamente extendidos.",
      "Aprieta por 1 segundo la contracción máxima.",
      "Regresa lentamente a la posición inicial, controlando el movimiento y manteniendo la tensión.",
      "Repite el movimiento por el número de repeticiones indicado.",
    ],
    muscles: ["Tríceps braquial (cabeza medial y lateral)"],
    benefits: [
      "Aumenta la fuerza y definición de los brazos.",
      "Mejora el tamaño del tríceps.",
      "Menor estrés en las muñecas.",
      "Mayor activación del tríceps con agarre supino.",
      "Ideal para todos los niveles.",
    ],
    keys: [
      "Mantén los codos pegados al cuerpo.",
      "Usa un rango completo de movimiento.",
      "Evita balancear el cuerpo.",
      "Controla la fase excéntrica (subida).",
      "Respira: exhala al extender, inhala al subir.",
    ],
    errors: [
      "Abrir los codos durante el movimiento.",
      "Usar demasiado peso y balancear el cuerpo.",
      "No extender completamente los brazos.",
      "Mover solo las muñecas en lugar de los brazos.",
      "No controlar la fase excéntrica.",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 15 REPETICIONES",
    rest: "60 - 90 SEG",
  },
  {
    id: "triceps-polea-barra",
    name: "Extensión de Tríceps en Polea con Barra",
    muscle_group: "triceps",
    equipment: "gym",
    tags: ["fuerza", "volumen", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/pn60a7ig_file_000000006ad471f5ae1583879dc0c5a1.png",
    execution: [
      "De pie frente a la polea alta con una barra recta enganchada.",
      "Sujeta la barra con agarre prono (palmas hacia abajo), manos a la anchura de los hombros.",
      "Mantén los codos pegados al torso y los antebrazos paralelos al suelo.",
      "Extiende los codos empujando la barra hacia abajo hasta extensión completa.",
      "Contrae el tríceps al final del movimiento por 1 segundo.",
      "Regresa lentamente a la posición inicial controlando el peso.",
    ],
    muscles: ["Tríceps braquial (cabeza lateral y medial)", "Ancóneo"],
    benefits: [
      "Permite mover cargas más altas que con cuerda.",
      "Enfatiza las cabezas lateral y medial del tríceps.",
      "Da grosor y definición al brazo.",
      "Fortalece la extensión del codo.",
    ],
    keys: [
      "Codos pegados al torso, FIJOS.",
      "Solo mueven los antebrazos.",
      "No uses impulso ni balancees el cuerpo.",
    ],
    errors: [
      "Mover los codos hacia adelante.",
      "Inclinar el torso hacia adelante para empujar más peso.",
      "No completar la extensión del codo.",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 12 REPETICIONES",
    rest: "45 - 60 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/6zpxsjwv_709853216_1783022610409443.mp4",
  },
  {
    id: "triceps-mancuerna-overhead",
    name: "Tríceps con Mancuernas (Overhead)",
    muscle_group: "triceps",
    equipment: "gym",
    tags: ["cabeza larga", "estiramiento", "volumen"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/hrllb1ew_file_0000000041a871f5a8da354c56c502f4.png",
    execution: [
      "Siéntate en un banco con la espalda recta y firme.",
      "Sostén una mancuerna con ambas manos sobre tu cabeza, brazos completamente extendidos.",
      "Mantén los codos apuntando hacia adelante y pegados a la cabeza.",
      "Flexiona los codos bajando la mancuerna detrás de la cabeza de forma controlada.",
      "Detente cuando sientas un buen estiramiento en el tríceps.",
      "Extiende los brazos contrayendo el tríceps hasta la posición inicial.",
    ],
    muscles: ["Tríceps braquial (cabeza larga)", "Ancóneo"],
    benefits: [
      "Enfatiza la cabeza larga del tríceps (parte trasera y baja).",
      "Excelente para volumen y grosor del brazo.",
      "Estiramiento profundo del tríceps.",
      "Complemento perfecto de las extensiones en polea.",
    ],
    keys: [
      "Mantén los codos apuntando hacia adelante.",
      "No muevas los codos hacia los lados.",
      "Controla el movimiento en todo momento.",
      "Enfócate en la contracción del tríceps.",
    ],
    errors: [
      "Abrir los codos hacia los lados.",
      "Arquear excesivamente la espalda.",
      "Usar demasiado peso y perder técnica.",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 12 REPETICIONES",
    rest: "45 - 60 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/dhglszag_521561810_1783022595767146.mp4",
  },
  {
    id: "triceps-polea-cuerda",
    name: "Extensión de Tríceps en Polea con Cuerda",
    muscle_group: "triceps",
    equipment: "gym",
    tags: ["aislamiento", "definición", "volumen"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/rc730fne_file_00000000dc18720c9a528f0006dcbe03.png",
    execution: [
      "De pie frente a la polea alta con una cuerda enganchada.",
      "Sujeta la cuerda con ambas manos, palmas enfrentadas.",
      "Codos pegados al torso, antebrazos paralelos al suelo.",
      "Extiende los codos empujando la cuerda hacia abajo.",
      "En la parte final, separa las manos abriendo la cuerda.",
      "Regresa lentamente a la posición inicial con control.",
    ],
    muscles: ["Tríceps braquial (las 3 cabezas)", "Ancóneo"],
    benefits: [
      "Aísla completamente el tríceps.",
      "Excelente para definición y forma del brazo.",
      "Trabaja las tres cabezas del tríceps.",
      "Tensión constante durante todo el movimiento.",
    ],
    keys: [
      "Mantén los codos FIJOS pegados al torso.",
      "Solo mueven los antebrazos.",
      "Separa la cuerda al final para máxima contracción.",
    ],
    errors: [
      "Mover los codos hacia adelante.",
      "Usar demasiado peso y balancearse.",
      "No completar la extensión.",
    ],
    sets: "3 - 4 SERIES",
    reps: "10 - 15 REPETICIONES",
    rest: "45 SEG",
  },
  {
    id: "fondos-banco",
    name: "Fondos en Banco",
    muscle_group: "triceps",
    equipment: "gym",
    tags: ["peso corporal", "fuerza", "volumen"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/bgj3n6ak_file_00000000f48471f5bbbbff32ef446550.png",
    execution: [
      "Apoya las manos en el borde de un banco detrás de ti.",
      "Extiende las piernas hacia adelante, apoyadas en los talones.",
      "Mantén los brazos extendidos, la cadera cerca del banco.",
      "Baja flexionando los codos hacia atrás (no hacia los lados).",
      "Desciende hasta que los codos formen 90°.",
      "Empuja con los tríceps hasta extender los brazos.",
    ],
    muscles: ["Tríceps braquial", "Pectoral inferior", "Deltoides anterior"],
    benefits: [
      "Ejercicio efectivo con peso corporal.",
      "Fortalece los tríceps y el pecho inferior.",
      "Puede hacerse en cualquier lugar.",
      "Se puede progresar añadiendo peso en las piernas.",
    ],
    keys: [
      "Codos hacia atrás, NO hacia afuera.",
      "Cadera pegada al banco.",
      "Baja controlado.",
    ],
    errors: [
      "Abrir los codos hacia los lados (estrés en hombros).",
      "Alejarse del banco.",
      "No bajar lo suficiente.",
    ],
    sets: "3 SERIES",
    reps: "10 - 20 REPETICIONES",
    rest: "45 - 60 SEG",
  },
  {
    id: "press-frances",
    name: "Press Francés con Barra (Skull Crushers)",
    muscle_group: "triceps",
    equipment: "gym",
    tags: ["masa", "cabeza larga", "aislamiento"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/ucveseyo_file_000000000c40720ca4e53d615bc022cb.png",
    execution: [
      "Recuéstate en un banco plano con una barra Z o EZ.",
      "Sujeta la barra con agarre prono, manos a la anchura de los hombros.",
      "Extiende los brazos verticalmente sobre el pecho.",
      "Flexiona SOLO los codos, bajando la barra hacia la frente.",
      "Detente justo antes de tocar la frente.",
      "Extiende los codos regresando a la posición inicial.",
    ],
    muscles: ["Tríceps braquial (cabeza larga)", "Ancóneo"],
    benefits: [
      "Enfatiza la cabeza larga del tríceps (parte trasera del brazo).",
      "Excelente para masa muscular en tríceps.",
      "Aísla el tríceps al fijar el hombro.",
      "Da grosor al brazo.",
    ],
    keys: [
      "Codos apuntando al techo, FIJOS.",
      "Solo se mueven los antebrazos.",
      "Baja controlado, evita chocar la frente.",
    ],
    errors: [
      "Mover los codos hacia afuera o adelante.",
      "Usar demasiado peso.",
      "Bajar demasiado rápido.",
    ],
    sets: "3 - 4 SERIES",
    reps: "8 - 12 REPETICIONES",
    rest: "60 SEG",
  },

  // ============== ABDOMEN / CORE ==============
  {
    id: "abdominal-polea",
    name: "Abdominal en la Polea",
    muscle_group: "core",
    equipment: "gym",
    tags: ["fuerza", "control", "definición"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/e9ojgkgk_file_000000005bf8722fbd91c493be66f36d.png",
    execution: [
      "Arrodíllate frente a la polea alta con una cuerda enganchada.",
      "Sujeta la cuerda con ambas manos a cada lado de la cabeza.",
      "Mantén los codos flexionados y cerca de las orejas.",
      "Espalda recta y abdomen contraído en la posición inicial.",
      "Contrae el abdomen llevando los codos hacia las rodillas en un movimiento de flexión de columna.",
      "Al final del movimiento, redondea la espalda y contrae fuertemente el abdomen por 1-2 segundos.",
      "Regresa lentamente a la posición inicial extendiendo la columna sin arquear la espalda.",
    ],
    muscles: ["Recto abdominal (principal)", "Oblicuos (internos y externos)", "Transverso del abdomen", "Flexores de la cadera (estabilizadores)"],
    benefits: [
      "Fortalece y define el recto abdominal.",
      "Mejora la estabilidad del core.",
      "Ayuda a desarrollar un abdomen más funcional y estético.",
      "Aumenta la fuerza en movimientos compuestos.",
      "Mejora el control corporal y la postura.",
    ],
    keys: [
      "Usa un peso que te permita mantener la técnica perfecta.",
      "El movimiento debe salir del abdomen, no de los brazos.",
      "Mantén los codos fijos y cerca de la cabeza.",
      "Exhala al contraer el abdomen.",
      "Evita balanceos o impulsos.",
      "Realiza un rango completo de movimiento.",
    ],
    errors: [
      "Usar demasiado peso y comprometer la técnica.",
      "Jalar con los brazos en lugar de contraer el abdomen.",
      "Arquear la espalda al regresar.",
      "No hacer un rango completo.",
      "Balancear el cuerpo o usar impulso.",
    ],
    sets: "3 - 4 SERIES",
    reps: "12 - 20 REPETICIONES",
    rest: "30 - 60 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/tenx8x0a_216965972_1783028768741631.mp4",
  },
  {
    id: "elevacion-piernas",
    name: "Elevación de Piernas Colgado (Abdominal)",
    muscle_group: "core",
    equipment: "gym",
    tags: ["abdomen inferior", "fuerza", "control"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/f5fquhma_file_00000000df4c71f780ec926105da3776.png",
    execution: [
      "Sujétate firmemente de la barra con las palmas hacia adelante, separación al ancho de los hombros.",
      "Extiende completamente los brazos y cuelga con el cuerpo recto. Activa el core.",
      "Mantén las piernas juntas y estiradas, con los pies ligeramente hacia adelante.",
      "Evita balancearte y mantén la espalda recta.",
      "Contrae el abdomen y eleva las piernas juntas hacia arriba, llevando las rodillas o los pies hacia el pecho.",
      "En la parte más alta, contrae fuertemente el abdomen y mantén la posición durante 1 segundo.",
      "Baja las piernas de forma lenta y controlada, sin perder la tensión en el abdomen, hasta llegar a la posición inicial.",
    ],
    muscles: ["Recto abdominal (parte inferior)", "Flexores de cadera", "Oblicuos (estabilizadores)", "Core en general"],
    benefits: [
      "Uno de los ejercicios más efectivos para trabajar el abdomen inferior.",
      "Mejora la fuerza, estabilidad y control del core.",
      "Ideal para definir, tonificar y fortalecer la zona media.",
      "Fortalece los flexores de cadera.",
      "Progresa por niveles (rodillas flexionadas → piernas extendidas).",
    ],
    keys: [
      "Evita balanceos y movimientos bruscos.",
      "Mantén el core siempre activado.",
      "Espalda recta y hombros estables.",
      "No uses impulso para subir las piernas.",
      "Respira: exhala al subir, inhala al bajar.",
    ],
    errors: [
      "Balancear el cuerpo.",
      "Usar impulso para elevar las piernas.",
      "Separar las piernas.",
      "Arquear la espalda.",
      "No contraer el abdomen.",
    ],
    sets: "3 - 5 SERIES",
    reps: "10 - 20 REPETICIONES",
    rest: "45 - 60 SEG",
  },
  {
    id: "plancha-frontal",
    name: "Plancha Frontal",
    muscle_group: "core",
    equipment: "any",
    tags: ["isométrico", "core", "estabilidad"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/tcj4fsh0_file_00000000abb0722f81f230badd147e88.png",
    execution: [
      "Apóyate en el suelo con los antebrazos y las puntas de los pies.",
      "Codos alineados directamente bajo los hombros.",
      "Cuerpo formando una línea recta desde la cabeza hasta los talones.",
      "Contrae glúteos, abdomen y aprieta el core.",
      "Mantén la posición sin dejar caer la cadera ni elevarla.",
      "Respira de forma controlada durante toda la duración.",
    ],
    muscles: ["Recto abdominal", "Transverso abdominal", "Oblicuos", "Erectores espinales"],
    benefits: [
      "Fortalece todo el core de forma integral.",
      "Mejora la postura y estabilidad.",
      "Previene dolores lumbares.",
      "Base fundamental para todos los ejercicios compuestos.",
    ],
    keys: [
      "Cuerpo en línea recta perfecta.",
      "Aprieta glúteos y abdomen constantemente.",
      "No mires al techo, mira al suelo.",
    ],
    errors: [
      "Bajar la cadera (arco lumbar).",
      "Elevar la cadera (posición de pico).",
      "Aguantar la respiración.",
    ],
    sets: "3 - 4 SERIES",
    reps: "30 - 60 SEGUNDOS",
    rest: "30 - 45 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/tlivm07y_download_20260702_174427_0000.mp4",
  },
  {
    id: "crunch-abdominal",
    name: "Crunch Abdominal",
    muscle_group: "core",
    equipment: "any",
    tags: ["abdomen superior", "definición", "básico"],
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/i8kl5505_file_00000000286c722f9c9ef32aea4d3b7e.png",
    execution: [
      "Recuéstate boca arriba con las rodillas flexionadas y pies apoyados.",
      "Coloca las manos detrás de la cabeza o cruzadas en el pecho.",
      "Contrae el abdomen elevando el torso hacia las rodillas.",
      "Sube solo hasta que las escápulas se despeguen del suelo.",
      "Contrae al máximo en la parte alta por 1 segundo.",
      "Baja lentamente controlando el descenso.",
    ],
    muscles: ["Recto abdominal (parte superior)", "Oblicuos"],
    benefits: [
      "Aísla el recto abdominal superior.",
      "Excelente para definición del six pack.",
      "Ejercicio seguro para principiantes.",
      "Se puede hacer en cualquier lugar.",
    ],
    keys: [
      "No tires del cuello con las manos.",
      "Sube contrayendo el abdomen, no impulsándote.",
      "Baja lento (2-3 segundos).",
    ],
    errors: [
      "Tirar del cuello con las manos.",
      "Subir demasiado (se involucran flexores de cadera).",
      "Movimiento muy rápido sin contracción.",
    ],
    sets: "3 - 4 SERIES",
    reps: "15 - 25 REPETICIONES",
    rest: "30 SEG",
    video_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/b30b4ugz_download_20260702_174020_0000.mp4",
  },
];

export const MUSCLE_GROUPS = [
  { id: "all", label: "Todos" },
  { id: "back", label: "Espalda" },
  { id: "chest", label: "Pecho" },
  { id: "shoulders", label: "Hombros" },
  { id: "biceps", label: "Bíceps" },
  { id: "triceps", label: "Tríceps" },
  { id: "legs", label: "Piernas" },
  { id: "core", label: "Abdomen" },
];
